module.exports = __webpack_public_path__ + "assets/images/planche-placeholder-a37b37d99e7cef805f354d474121bfef.png";